import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
import ChinaReqMain from "./ChinaReqMain";
const ChinaReq = () => {
  return (
    <div className="uaeReqContainer">
      <ChinaReqMain />
    </div>
  );
};

export default ChinaReq;
